import { useInfiniteQuery } from "@tanstack/react-query";
import { getTasksByItem } from "./tasks.service";
import { DEFAULT_TASK_PAGE_SIZE } from "../constants/TaskTypeNames";
import type { Task } from "../types/Task";
import { getMediaTasksByItemQueryKey } from "./queryKeyHelper";

type PageParam = string | undefined;

type TasksPage = {
  tasks: Task[];
  lastSeenCreatedAt: string | null;
  lastSeenTaskId: string | null;
  totalCount: number;
};

/**
 * Hook to fetch v2 tasks filtered by item number and task type IDs
 * Queries across all medias (no media filter)
 * Uses infinite query for pagination with cursor (updated_at ISO 8601 timestamp)
 */
export function useTasksByItem(
  itemNo: string | undefined,
  storeId: string | undefined,
  taskTypeIds: string[]
) {
  return useInfiniteQuery({
    queryKey: getMediaTasksByItemQueryKey(itemNo, storeId, taskTypeIds),
    queryFn: ({ pageParam }: { pageParam: PageParam }) => {
      if (!itemNo || !storeId) {
        throw new Error("itemNo and storeId are required");
      }
      return getTasksByItem(
        itemNo,
        storeId,
        taskTypeIds,
        DEFAULT_TASK_PAGE_SIZE,
        pageParam
      );
    },
    getNextPageParam: (lastPage: TasksPage) => {
      // Backend uses updated_at timestamp as cursor for pagination
      return lastPage.lastSeenCreatedAt || undefined;
    },
    enabled: !!itemNo && !!storeId && taskTypeIds.length > 0,
    staleTime: 30000,
    gcTime: 60000,
    initialPageParam: undefined as PageParam,
  });
}
